// Function to dynamically load CSS
function loadCSS(url) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
}
  
// Function to dynamically load JS
function loadJS(url, callback) {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;

    // Once the script is loaded, execute the callback function
    script.addEventListener('load', callback);

    document.body.appendChild(script);
}

function createCardForm() {
    const paymentForm = document.createElement('div');
    paymentForm.className = 'payment-form';

    // Load CardJs CSS from CDN
    loadCSS('https://cdn.jsdelivr.net/npm/card-js@1.0.13/card-js.min.css');

    // Load CardJs JS from CDN and initialize when loaded
    loadJS('https://cdn.jsdelivr.net/npm/card-js@1.0.13/card-js.min.js', function() {
        console.log('CardJs loaded successfully');

        paymentForm.innerHTML = `
            <div class="card-js" id="my-card" data-capture-name="true">
                <input id="cardNumber" class="card-number" name="card-number">
                <input id="cardName" class="name" name="card-holders-name" placeholder="Name on card">
                <input id="expiryMonth" class="expiry-month" name="expiry-month">
                <input id="expiryYear" class="expiry-year" name="expiry-year">
                <input id="cardCode" class="cvc" name="cvc">
            </div>
        `;
        $(`.${paymentForm.className}`).html(paymentForm.innerHTML);
    });
}

// Export the createCardForm function for use in other files
export { createCardForm };